import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import BidModal from './BidModal';
import { typeLabel, normalizeGender } from '../config/horseOptions';

const AuctionCard = ({ auction, onRefresh }) => {
  const [showBidModal, setShowBidModal] = useState(false);

  const statusBadge = {
    active: 'badge-live',
    scheduled: 'badge-scheduled',
    ended: 'badge-ended'
  };

  const statusText = {
    active: 'LIVE',
    scheduled: 'PROSSIMA',
    ended: 'TERMINATA'
  };

  const horseType = auction.horse?.horse_type;
  const pregnantWith = auction.horse?.pregnant_with;

  // Build horse type label with pregnancy info
  const getHorseTypeLabel = () => {
    let label = typeLabel(horseType);
    if (pregnantWith) {
      label += ` – incinta di ${pregnantWith}`;
    }
    return label;
  };

  return (
    <>
      <div className="auction-card block" data-testid={`auction-card-${auction.auction_id}`}>
        <a href={`/asta/${auction.auction_id}`} className="block">
          <div className="relative overflow-hidden">
            {auction.horse?.images?.[0] ? (
              <img 
                src={auction.horse.images[0]} 
                alt={auction.horse?.name}
                className="card-image w-full h-48 sm:h-56 md:h-64 object-cover"
              />
            ) : (
              <div className="w-full h-48 sm:h-56 md:h-64 bg-gray-200 flex items-center justify-center">
                <span className="text-gray-400">Nessuna immagine</span>
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
              <span className="text-white text-xs font-medium">
                {getHorseTypeLabel()}
              </span>
            </div>
            <div className="absolute top-3 left-3">
              <span className={statusBadge[auction.status]}>{statusText[auction.status]}</span>
            </div>
          </div>
          <div className="p-4">
            <h3 className="font-display text-base md:text-lg font-bold mb-1">{auction.horse?.name || auction.title}</h3>
            {auction.horse && (
              <p className="text-[#64748b] text-xs mb-1">
                {normalizeGender(auction.horse.gender)} {auction.horse.age ? `${auction.horse.age} anni` : ''} {auction.horse.breed ? `\u2022 ${auction.horse.breed}` : ''}
              </p>
            )}
            {auction.status === 'active' && (
              <div className="mt-2">
                <div className="flex items-center justify-between text-xs text-[#64748b] mb-1">
                  <span>CHIUSURA</span>
                  <CountdownTimer endTime={auction.end_time} />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[10px] text-[#64748b] uppercase">Offerta migliore</span>
                  <span className="text-base font-bold">{'\u20AC'}{auction.current_price?.toLocaleString()}</span>
                </div>
              </div>
            )}
            {auction.status === 'ended' && (
              <div className="mt-2">
                <div className="flex items-center justify-between text-xs mb-1">
                  <span className="text-[#64748b]">FINALE</span>
                  <span className="text-[#64748b]">Completato</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[10px] text-[#64748b] uppercase">Offerta migliore</span>
                  <span className="text-base font-bold">{'\u20AC'}{auction.current_price?.toLocaleString()}</span>
                </div>
              </div>
            )}
          </div>
        </a>
        {/* Two Buttons: Mostra offerta + Info */}
        <div className="px-4 pb-4 flex gap-2" data-testid="auction-card-actions">
          <button 
            onClick={(e) => { e.preventDefault(); setShowBidModal(true); }}
            className="flex-1 py-2.5 bg-[#e8e8e8] text-[#333] border border-transparent rounded text-sm font-medium hover:bg-white hover:border-[#0a7e8c] hover:text-[#0a7e8c] transition-colors"
            data-testid={`show-bid-${auction.auction_id}`}
          >
            Mostra l'offerta
          </button>
          <a 
            href={`/asta/${auction.auction_id}`}
            className="w-10 h-10 bg-[#e8e8e8] text-[#333] border border-transparent rounded flex items-center justify-center hover:bg-white hover:border-[#0a7e8c] hover:text-[#0a7e8c] transition-colors font-serif italic text-sm"
            data-testid={`info-btn-${auction.auction_id}`}
          >
            i
          </a>
        </div>
      </div>

      {/* Bid Modal */}
      {showBidModal && (
        <BidModal auction={auction} onClose={() => setShowBidModal(false)} onBidPlaced={onRefresh} />
      )}
    </>
  );
};

export default AuctionCard;
